module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home",
    class: _vm.theme,
    attrs: {
      "id": "home"
    }
  }, [_c('swiper', {
    ref: "mySwiper",
    attrs: {
      "options": _vm.swiperOption
    }
  }, [_c('swiper-slide', [_c('div', {
    staticStyle: {
      "height": "100%",
      "background-image": "url('../assets/img/bg1512.jpg')",
      "background-size": "cover",
      "background-repeat": "no-repeat"
    }
  }, [_c('div', {
    staticClass: "slide-center"
  }, [_c('div', [_c('img', {
    staticStyle: {
      "width": "auto",
      "height": "40vh"
    },
    attrs: {
      "src": _vm.logoUrl,
      "alt": "Bonell+Dòriga"
    },
    on: {
      "mouseover": function($event) {
        _vm.logoUrl = _vm.logoHighlightUrl
      },
      "mouseout": function($event) {
        _vm.logoUrl = _vm.logoNormalUrl
      },
      "click": function($event) {
        _vm.goTo('main')
      }
    }
  })])])])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2078095a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Home.vue
// module id = 2119
// module chunks = 0